import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import { Product } from '@domain/product/models/Product';

interface LeadTimeDisplayProps {
  product: Product;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const LeadTimeDisplay: React.FC<LeadTimeDisplayProps> = ({ product, onClick }) => {


  const totalDuration = (product.productionDuration || 0) +
    (product.processingDuration || 0) +
    (product.defaultShipmentMethod?.duration || 0);

  return (
    <Stack
      onClick={onClick}
      direction="row"
      alignItems="center"
      gap={1}
    >
      <Typography variant="body2" noWrap>
        {totalDuration ? totalDuration + ' days = ' : 'Not set'}
      </Typography>
      <Chip
        label={`${product.productionDuration || 0} + ${product.defaultShipmentMethod?.duration || 0} + ${product.processingDuration || 0}`}
        color="info"
        size="small"
        sx={{ cursor: 'pointer' }}
      />
    </Stack>
  );
};

export default LeadTimeDisplay;
